export const PAGE_NAME = ["gp-zlp-nbn", "gp-vnp-nbn", "gp-spp-nbn"];

export enum PageName {
  SHOPEE = "gp-spp-nbn",
  ZALO = "gp-zlp-nbn",
  VNPAY = "gp-vnp-nbn",
}

export const MKT_CAMPAIGN = {
  VNPAY: "pns_landing_vnp_nbn",
  ZALO: "pns_landing_zlp_nbn",
  SHOPEE: "pns_landing_spp_nbn",
};
export enum OFFER_CHANNEL {
  ZALOPAY = "ZALOPAY",
  SHOPEEPAY = "SHOPEEPAY",
  VNPAY = "VNPAY",
}
export enum PAYMENT_CHANELS {
  ZALOPAY = "ZALOPAY",
  SHOPEEPAY = "SHOPEEPAY",
  "VNPAY-QR" = "VNPAY-QR",
}

// REACT_APP_CAMPAIGN = "ShopeePay";
// REACT_APP_METHODS_KEY = "625f653c-c850-11eb-b22c-0242ac132324";
// REACT_APP_CHANEL_TYPE = "SHOPEEPAY";

// Thông tin tracking:
// event: PNS_NBN
// eventAction: PNS_SPP_NBN
// eventCategory: PNS TVOD Landing page
// eventLabel: PNS-TVOD-GPVNP50k

// Thông tin tracking:
// event: PNS_NBN
// eventAction: PNS_SPP_NBN
// eventCategory: PNS TVOD Landing page
// eventLabel: PNS-TVOD-GPSPP50k

// Thông tin tracking:
// event: PNS_NBN
// eventAction: PNS_SPP_NBN
// eventCategory: PNS TVOD Landing page
// eventLabel: PNS-TVOD-GPZLP50k
